package com.downdogapp.client.controllers.start

import com.downdogapp.client.*
import com.downdogapp.client.StatType.TOTAL_PRACTICES
import com.downdogapp.client.controllers.SelectorOption
import com.downdogapp.client.controllers.SelectorViewController
import com.downdogapp.client.singleton.App
import com.downdogapp.client.singleton.Key
import com.downdogapp.client.singleton.UserPrefs
import com.downdogapp.client.views.start.StatsPageView

object StatsPage : Page {

  var activeYearMonth = YearMonthDay.today.yearMonth; private set

  var displayAllAppTypes = true
    set(value) {
      if (field != value) {
        logEvent("update_display_all_app_types", mapOf("value" to value.toString()))
        field = value
        view.refreshView()
      }
    }

  private var activeStatType
    get() = UserPrefs[Key.StatTypeId]?.let { StatType.fromId(it) } ?: TOTAL_PRACTICES
    set(value) {
      UserPrefs[Key.StatTypeId] = value.id
    }

  val weeklyGoalDescription
    get() =
      Strings.WEEKLY_GOAL

  val weeklyGoalDisplayString
    get() =
      "${StatsUtil.practicesThisWeek} / ${StatsUtil.weeklyGoal}"

  val statDescription
    get() =
      StatsUtil.getStatDescription(activeStatType, activeYearMonth)

  val statDiplayString
    get() =
      StatsUtil.getDisplayStringForStat(activeStatType, activeYearMonth)

  override val view = StatsPageView()

  override fun refreshPage() {
    view.refreshView()
  }

  fun incrementMonth() {
    logEvent("history_increment_month")
    activeYearMonth = activeYearMonth.nextMonth()
    view.refreshCalendar()
  }

  fun decrementMonth() {
    logEvent("history_decrement_month")
    activeYearMonth = activeYearMonth.previousMonth()
    view.refreshCalendar()
  }

  fun weeklyGoalSelectorClicked() {
    App.pushViewController(
      SelectorViewController(
        title = Strings.WEEKLY_GOAL_SELECTOR_TITLE,
        subtitle = Strings.WEEKLY_GOAL_SUBTITLE,
        options = (1..30).map {
          SelectorOption(
            id = it,
            label = it.toString()
          )
        },
        initialSelectedId = StatsUtil.weeklyGoal,
        onOptionSelected = {
          logEvent("weekly_goal_updated", mapOf("value" to it.toString()))
          UserPrefs[Key.WeeklyGoal] = it
          view.refreshView()
        }
      )
    )
  }

  fun statTypeSelectorClicked() {
    App.pushViewController(
      SelectorViewController(
        title = Strings.STAT_TYPE_TITLE,
        subtitle = Strings.STAT_TYPE_SUBTITLE,
        options = StatType.ALL_SELECTOR_OPTIONS,
        initialSelectedId = activeStatType.id,
        onOptionSelected = {
          logEvent(
            "history_stat_type_updated",
            mapOf("id" to it.toString(), "type" to StatType.fromId(it).name)
          )
          activeStatType = StatType.fromId(it)
          view.refreshView()
        }
      )
    )
  }

  fun calendarSelectWeekStart() {
    App.pushViewController(
      SelectorViewController(
        title = Strings.WEEK_START_TITLE,
        options = FirstDayOfWeek.ALL_SELECTOR_OPTIONS,
        initialSelectedId = StatsUtil.firstDayOfWeek.id,
        onOptionSelected = {
          logEvent("history_updated_first_day_of_week", mapOf("value" to it.toString()))
          UserPrefs[Key.FirstDayOfWeekId] = it
          view.refreshView()
        }
      )
    )
  }

  override val shouldDisplay: Boolean
    get() = MANIFEST.displayStatsPage

  override val title: String
    get() = MANIFEST.statsPageTitle
}
